import { render, staticRenderFns } from "./IconPhoneLight.vue?vue&type=template&id=1b0e5fb0&"
import script from "./IconPhoneLight.vue?vue&type=script&lang=js&"
export * from "./IconPhoneLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports